import { Flex, Text } from '@chakra-ui/core'
import styled from '@emotion/styled'

export const LastMessageBox = styled(Flex)<{ dir: string; isPersonalView?: boolean }>`
  direction: ${({ dir }) => dir};
  position: absolute;
  flex-direction: column;
  justify-content: center;
  padding: 8px 12px;
  top: -18px;
  z-index: 100;
  min-height: 38px;
  border-radius: 10px;
  background: white;
  min-width: 90px;
  max-width: ${({ isPersonalView }) => (isPersonalView ? '200px' : '120px')};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  &:after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: ${({ isPersonalView }) => (isPersonalView ? '15px' : '55px')};
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid white;
    filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1));
  }
`

export const ChatPreviewText = styled(Text)`
  word-break: break-word;
  unicode-bidi: plaintext;
  display: -webkit-box;
  font-size: 11px;
  max-width: 80px;
  overflow: hidden;
  line-height: 12px;
  text-align: center;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const ChatPreviewContainer = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  padding-left: 15px;
  padding-right: 18px;
  margin-bottom: 18px;
`

export const ChatPreviewTitle = styled(Text)`
  max-width: 60px;
  text-align: center;
  font-size: 12px;
  margin-top: 12px;
  font-weight: 500;
`
